export default "__VITE_ASSET__CGFHw3Fk__"